export default __webpack_public_path__ + "static/media/LVGMC-logo.2269b656.svg";